export const activeHeaderButtonColor = "#BDA000";
export const textColor1 = "#FFD700";
export const textColor2 = "#F9C349";
export const subTitleColor = "#4B4F58";
export const backgroundColor = "#eeeeed";
